export const Settings = {
    DomainServiceUrl: 'https://domain.bloyal.io',
    BaseUrl: 'https://snippets2.bloyal.io',
    ConfigStorageName: "myrewards1",
    WalletDownloadUrl: 'https://wc.bloyal.io',
    SiteType: 2,
    ServiceUrls: {
        // LoyaltyEngineApiUrl: 'http://localhost:49653',
        // WebSnippetsApiUrl: 'http://localhost:55253'
    }
}